import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import React from "react";
import { PDFReader } from "reactjs-pdf-reader";

export default function VerPdf(props) {
  //const [close, setClose] = React.useState(true);
  const [mostra, setMostra] = React.useState(false);

  return (
    <div>
      <Dialog /*fullScreen*/ maxWidth="xl" open={props.abrir}>
        <div style={{ overflow: "scroll" }} id="imprime_esto">
          <PDFReader showAllPage isShowHeader isShowFooter url={props.url} />
        </div>

        <DialogActions
          style={mostra ? { display: "none" } : { display: "flex" }}
        >
          <Button
            download
            target="_parent"
            href={props.url}
            variant="contained"
            color="primary"
          >
            Descargar
          </Button>
          <Button
            target="_blank"
            onClick={() => {
              setMostra(true);

              setTimeout(function() {
                window.print();
              }, 500);
              setTimeout(function() {
                setMostra(false);
              }, 1000);
            }}
            variant="outlined"
            color="primary"
          >
            Imprimir
          </Button>

          <Button onClick={props.cerrar} variant="contained" color="secondary">
            cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
